module.exports = __webpack_public_path__ + "img/ic-liquidate-marker.347273bb.svg";